import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "leftTable", "rightTable" ]

  connect() { 

    this.observer = new MutationObserver((mutations) => { 
      this.resize();
    });

    this.observer.observe(this.element, { 
      childList: true, 
      subtree: true 
    });
  }

  disconnect() {  
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  resize() { 
    const leftTds = this.element.querySelectorAll('.table-left td');
    const rightTds = this.element.querySelectorAll('.table-right td');
  
    if (leftTds.length === 0 && rightTds.length === 0) { 
      return;
    }
  
    this.observer.disconnect(); 

    let maxHeight = 0;
    const allTds = [...leftTds, ...rightTds];
 
    allTds.forEach(td => {
      if (td.clientHeight > maxHeight) {
        maxHeight = td.clientHeight;
      }
    });
 
    const style = document.createElement('style');
    style.innerHTML = `
      .table-left td, .table-right td {
          height: ${maxHeight - 16}px !important;
      }
    `;
    document.head.appendChild(style); 
  }
}